var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-address",
    clipPath: "url(#clip0_1167_664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48525 4.48525 0 10 0C15.5147 0 20 4.48525 20 10C20 15.5148 15.5147 20 10 20C4.48525 20 0 15.5148 0 10ZM1 10C1 14.963 5.037 19 10 19C14.963 19 19 14.963 19 10C19 5.037 14.963 1 10 1C5.037 1 1 5.037 1 10ZM8.09951 7.875L14.7773 4.55275L14.7802 4.55275C14.9706 4.45704 15.203 4.49513 15.3554 4.64747C15.5077 4.79787 15.5448 5.03029 15.4501 5.22267L12.1279 11.9004C12.081 11.9971 12.0009 12.0772 11.9033 12.125L5.2255 15.4473C5.15519 15.4824 5.07804 15.5 5.00285 15.5C4.87198 15.5 4.7421 15.4473 4.64737 15.3526C4.49503 15.2022 4.45792 14.9697 4.55265 14.7774L7.8749 8.09961C7.92177 8.00293 8.00185 7.92285 8.09951 7.875ZM6.11332 13.8886L10.8339 11.5401L8.46186 9.168L6.11332 13.8886ZM9.16793 8.46393L11.54 10.836L11.5411 10.8371L13.8907 6.11432L9.16793 8.46393Z",
    fill: "#B5B7BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1167_664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIcon);
export default __webpack_public_path__ + "static/media/browser_icon.71c3208daacf1e21686f0f9dfdfd7236.svg";
export { ForwardRef as ReactComponent };